<script setup lang="ts">
import type { ExtendedItem } from "@/interfaces";
import { computed } from "vue";

interface Props {
  model: string;
  item: ExtendedItem;
  groupId: string;
  enableIcon?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  enableIcon: true,
});

defineEmits(["update"]);

// Each time item should have 24h value as data-value
const timeValue = computed(() => {
  const { title } = props.item;

  const match = title.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!match) {
    return title;
  }

  let hours = parseInt(match[1], 10);
  const minutes = match[2];
  const period = match[3].toUpperCase();

  if (period === "AM" && hours === 12) hours = 0;
  else if (period === "PM" && hours !== 12) hours += 12;

  return `${String(hours).padStart(2, "0")}:${minutes}`;
});
</script>

<template>
  <button
    type="button"
    class="dropdown-focusable-item px-4 py-4 rounded-lg flex items-center w-full justify-start focus-visible-strong"
    :class="[
      model === item.value ? 'bg-darkOcean50' : '',
      item.disabled ? 'text-neutral500' : '',
      !item.disabled ? 'hover:bg-neutral50 active:bg-neutral100' : '',
      `dropdown-group-${groupId}`,
    ]"
    @click="$emit('update', item.value)"
    :disabled="item.disabled"
  >
    <div v-if="enableIcon" class="flex justify-center items-center w-9 mr-1">
      <i
        v-if="model === item.value"
        class="fa fa-check text-darkOcean500 text-xl"
      />
    </div>
    <div
      class="w-full text-left overflow-auto time-content"
      :data-value="timeValue"
    >
      {{ item.title }}
    </div>
  </button>
</template>
